import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { publicUrls } from 'src/environments/environment';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root',
})
export class AppInterceptorsService implements HttpInterceptor {
  constructor(private tokenService: TokenService) {}

  // Esta funcion verifica si la url que se le pasa por parametro esta incluida en el array de ulrs publicas que viene de environments.ts
  private isPublic(url: string): boolean {
    let isPublic = false;

    publicUrls.forEach((path) => {
      if (url.includes(path)) {
        isPublic = true;
      }
    });

    return isPublic;
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Si la req.url que se esta ejecutando es publica, entonces entra y se le agrega el header "From: Tienda".
    // Esto le da a entender al back que viene de la tienda ecommerce, entonce el back no le pide tener un token.
    if (this.isPublic(req.url)) {
      const headers = new HttpHeaders({
        From: 'Tienda',
      });

      const request = req.clone({
        headers,
      });

      return next.handle(request);
    } else {
      // Si la req.url que se esta ejecutando no es publica, entonces entra y se le agrega el header "Authorization: Bearer <token>".
      // El back verifica que el token sea valido, y de serlo entonces se va a poder ejecutar la request.
      const token = this.tokenService.getToken();

      const headers = new HttpHeaders({
        Authorization: `Bearer ${token}`,
      });

      const request = req.clone({
        headers,
      });

      return next.handle(request);
    }
  }
}
